import type { ReactNode } from "react";
import { Card, Description, HoverCard, HoverCardContent, HoverCardTrigger } from "@peer-start/ui/reducate";

export function SituationSourceSummary({
  id,
  title,
  tag,
  fit,
  status,
  href,
  excerpt,
  showHref = true,
  tone = "muted",
  struck = false,
}: {
  id?: string;
  title: string;
  tag?: string;
  fit?: ReactNode;
  status?: string;
  href: string;
  excerpt?: string;
  showHref?: boolean;
  tone?: "muted" | "success" | "danger" | "info";
  struck?: boolean;
}) {
  const statusTone =
    tone === "success"
      ? "bg-success text-success-foreground"
      : tone === "danger"
        ? "bg-destructive text-destructive-foreground"
        : tone === "info"
          ? "bg-info text-info-foreground"
          : "bg-muted text-muted-foreground";
  const titleClass = `block text-sm font-medium ${struck ? "text-muted-foreground line-through" : ""}`;
  return (
    <span className="min-w-0 flex-1">
      {excerpt && id ? (
        <HoverCard closeDelay={150} openDelay={200}>
          <HoverCardTrigger asChild>
            <button
              className={`${titleClass} rounded-sm text-left focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30`}
              data-control-id={`situation.sources.preview.${id}`}
              type="button"
            >
              {title}
            </button>
          </HoverCardTrigger>
          <HoverCardContent align="start" className="w-80" side="right">
            <Card className="shadow-md" padding="compact">
              <Description>{excerpt}</Description>
              <a
                className="mt-3 block text-xs break-all text-primary underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30"
                data-control-id={`situation.sources.open.${id}`}
                href={href}
                rel="noreferrer"
                target="_blank"
              >
                {href}
              </a>
            </Card>
          </HoverCardContent>
        </HoverCard>
      ) : (
        <span className={titleClass}>{title}</span>
      )}
      <span className="mt-1 flex min-w-0 items-center gap-2">
        {tag ? (
          <span className="shrink-0 rounded-md bg-muted px-1.5 py-0.5 text-xs font-medium text-muted-foreground">
            {tag}
          </span>
        ) : null}
        {fit}
        {status ? (
          <span className={`shrink-0 rounded-md px-1.5 py-0.5 text-xs font-medium ${statusTone}`}>
            {status}
          </span>
        ) : null}
        {showHref ? (
          <span className={`truncate text-xs text-muted-foreground ${struck ? "line-through" : ""}`}>{href}</span>
        ) : null}
      </span>
    </span>
  );
}
